
// import AccettazionePrenotazioniLazioListPage from "./pages/AccettazionePrenotazioniLazioListPage.vue";
import AccettazioneSsnEditViewPage from "./pages/AccettazioneSsnEditViewPage.vue";
import AccettazioneFrosinoneListPage from "./pages/AccettazioneSsnListaPage.vue";
import AccettazionePrenotazioniLazioListPage from "./pages/AccettazionePrenotazioniLazioListPage.vue"
import AccettazioneRicettaPrestazioniListaPage from "../ricettaprestazioniappuntamenti/pages/AccettazioneRicettaPrestazioniListaPage.vue";
import AccettazionePrestazioniAppuntamentiAccessiListPage from "../appuntamenti/pages/AccettazionePrestazioniAppuntamentiAccessiListPage.vue";
import AccettazioneSsnRiepilogoImpegnativeListPage from "../appuntamenti/pages/AccettazioneSsnRiepilogoImpegnativeListPage.vue"


export default {

    AccettazioneSsnEditViewPage,
    AccettazioneFrosinoneListPage,
    AccettazionePrenotazioniLazioListPage,
    AccettazioneRicettaPrestazioniListaPage,
    AccettazionePrestazioniAppuntamentiAccessiListPage,
    AccettazioneSsnRiepilogoImpegnativeListPage
};
